var English = "Tiếng Anh";
var French = "Tiếng Pháp";
var German = "Tiếng Đức";
var Italian = "Tiếng Ý";
var Japanese = "Tiếng Nhật";
var Korean = "Tiếng Hàn Quốc";
var Portuguese = "Tiếng Bồ Đào Nha";
var Russian = "Tiếng Nga";
var Spanish = "Tiếng Tây Ban Nha";
var Bahasa = "Tiếng Bahasa";
var Thai = "Tiếng Thái";
var Vietnamese = "Tiếng Việt";
var Turkish = "Tiếng Thổ Nhĩ Kỳ";
var Arabic = "Tiếng Ả Rập";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "Tiếng Trung giản thể",
	"Chinese-Traditional": "Tiếng Trung phồn thể",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
